const runtimeConfig =
  typeof window !== "undefined" ? window.__VIRTUEHRM_ADMIN_CONFIG__ || {} : {};

export const apiBaseUrl =
  runtimeConfig.API_BASE_URL || process.env.REACT_APP_API_BASE_URL || "";
